import { startApplication } from "./runtime/startup-screen";

void startApplication(() => import("./index"));
